module.exports = __webpack_public_path__ + "images/home/index/geekbang-cooperation-eee79f00816c81954b125c78bc7373d3.png";